<template>
    <base_location_modal :tabs_advanced="tabs_add">
        <template v-slot:location_general_info="{ location, name }">
            <yelo_general_tab :location="location"></yelo_general_tab>
        </template>

        <template v-slot:location_categories="{ location, name }">
            <div>NOT_READY </div>
        </template>

        <template v-slot:location_logs="{ location, name }">
            <div>NOT_READY </div>
        </template>

    </base_location_modal>
</template>

<script>
import base_location_modal from "../../base/location_modal/base_location_modal";
import yelo_general_tab from "./tabs/yelo_general_tab";


export default {
    name: "yelo_location_modal",
    components : {
        yelo_general_tab,
        base_location_modal,
    },
    data () {
        return {
            tabs_add : [

            ]
        }
    },
}
</script>

<style scoped>

</style>
